import React from "react";
import { Modal, Button } from "react-bootstrap";

const JsonModal = ({ show, onClose, payload }) => {
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>JSON Payload</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {payload ? (
          <pre
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              background: "#f8f9fa",
              padding: "1rem",
              borderRadius: "5px",
              fontSize: "0.9rem",
            }}
          >
            {JSON.stringify(payload, null, 2)}
          </pre>
        ) : (
          <p>No data available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JsonModal;
